export const css = {
    root: '_2IjykYbk',
    ' _key': 'apic-theme/dojo/grid-footer'
};
export default css;
